<template>
  <div class="manage-podcast">
    <el-row type="flex" align="middle" class="page-title">
      <i class="el-icon-menu mr-s" />
      <h3>{{ $route.params.id ? "Cập nhật podcast" : "Tạo mới podcast" }}</h3>
    </el-row>
    <el-row class="content">
      <el-col :span="24" :lg="20">
        <el-card shadow="never">
          <el-form :model="form" ref="form" :rules="rules">
            <el-form-item label="Tên" prop="name">
              <el-input
                v-model="form.name"
                :disabled="callingAPI"
                @input="handleGenerateSlug"
                placeholder="Tên podcast"
              />
            </el-form-item>
            <el-form-item label="Slug" prop="slug">
              <el-input v-model="form.slug" />
            </el-form-item>
            <el-form-item label="Mô tả" prop="description">
              <el-input
                type="textarea"
                :rows="3"
                v-model="form.description"
                :disabled="callingAPI"
                placeholder="Mô tả"
              />
            </el-form-item>
            <el-form-item label="Audio" prop="audio">
              <input
                type="file"
                @change="onAudioChange"
                accept="audio/mp3, audio/mp4"
              />
              <audio v-show="currentAudio || audioUrl" id="audio" controls>
                <source :src="audioUrl" id="src" />
              </audio>
            </el-form-item>
            <el-form-item label="Ảnh đại diện" prop="avatar">
              <input
                type="file"
                accept="image/png, image/jpeg, image/jpg, image/gif"
                @change="onAvatarChange"
              />
              <img
                v-show="currentAvatar || avatarUrl"
                id="preview-avatar"
                :src="avatarUrl"
                class="preview-avatar"
              />
            </el-form-item>
            <el-form-item label="Nội dung" prop="content">
              <div class="markdown-editor">
                <mavon-editor
                  language="en"
                  :subfield="false"
                  v-model="form.content"
                  ref="md"
                  @imgAdd="imgAdd"
                />
              </div>
            </el-form-item>
            <el-form-item label="SEO title">
              <el-input
                v-model="form.metaTitle"
                :disabled="callingAPI"
                placeholder="SEO title"
              />
            </el-form-item>
            <el-form-item label="SEO keyword">
              <el-input
                v-model="form.metaKeyword"
                :disabled="callingAPI"
                placeholder="SEO keyword"
              />
            </el-form-item>
            <el-form-item label="SEO description">
              <el-input
                v-model="form.metaDescription"
                :disabled="callingAPI"
                placeholder="SEO description"
              />
            </el-form-item>
          </el-form>
          <el-row type="flex" justify="end" class="mt-xl">
            <el-button
              class="mt-xl"
              type="primary"
              :loading="callingAPI"
              @click="handleManage"
            >
              {{ $route.params.id ? "Cập nhật" : "Tạo mới" }}
            </el-button>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { upload } from "@/services/storage";
import ENDPOINT from "@/config/endpoint";
import { replaceUrlResourceBlog } from "@/utils/common";
import {
  createPodcast,
  updatePodcast,
  fetchPodcastById,
} from "@/services/podcast";
const slugify = require("slugify");

export default {
  name: "CreateUpdatePodcast",
  data() {
    return {
      markdownOption: {
        language: "en",
      },

      callingAPI: false,

      form: {
        name: "",
        slug: "",
        description: "",
        content: "",
        photo_url_path: "",
        audio_url_path: "",
        metaTitle: "",
        metaKeyword: "",
        metaDescription: "",
        show_home: null,
        status: 1,
      },
      rules: {
        name: [
          {
            required: true,
            message: "Giá trị không được để trống",
            trigger: ["blur", "change"],
          },
        ],
        description: [
          {
            required: true,
            message: "Giá trị không được để trống",
            trigger: ["blur", "change"],
          },
        ],
        content: [
          {
            required: true,
            message: "Giá trị không được để trống",
            trigger: ["blur", "change"],
          },
        ],
      },

      currentAvatar: null,
      avatarUrl: "",
      currentAudio: null,
      audioUrl: "",
    };
  },
  async beforeMount() {
    if (this.$route.params.id) {
      await this.loadData();
    }
  },
  methods: {
    async loadData() {
      this.callingAPI = true;
      const response = await fetchPodcastById(this.$route.params.id);
      this.form.name = response.data.name;
      this.form.slug = response.data.slug;
      this.form.description = response.data.description;
      this.form.content = response.data.content;
      this.form.photo_url_path = response.data.photo_url_path;
      this.form.audio_url_path = response.data.audio_url_path;
      this.form.metaTitle = response.data.meta_title;
      this.form.metaDescription = response.data.meta_description;
      this.form.metaKeyword = response.data.meta_keyword;
      this.form.show_home = response.data.show_home;
      this.form.status = response.data.status;

      this.avatarUrl = replaceUrlResourceBlog(response.data.photo_url_path);
      this.audioUrl = `${ENDPOINT.BACKEND_URL}/${response.data.audio_url_path}`;

      document.getElementById("audio").load();
      this.callingAPI = false;
    },

    imgAdd(pos, $file) {
      const formdata = new FormData();
      formdata.append("upload", $file);
      formdata.append("type", "posts");
      upload(formdata).then((res) => {
        this.$refs.md.$img2Url(
          pos,
          res?.data?.length ? `${ENDPOINT.BACKEND_URL}${res.data[0].path}` : ""
        );
      });
    },

    onAvatarChange(e) {
      if (e.target.files.length) {
        const file = e.target.files[0];
        this.currentAvatar = file;
        this.avatarUrl = URL.createObjectURL(file);
      }
    },

    onAudioChange(e) {
      if (e.target.files.length) {
        const file = e.target.files[0];
        this.currentAudio = file;
        this.audioUrl = URL.createObjectURL(file);
        document.getElementById("audio").load();
      }
    },

    handleGenerateSlug() {
      this.form.slug = slugify(this.form.name);
    },

    async handleUploadAvatar() {
      let formDataAvatar = new FormData();
      formDataAvatar.append("upload", this.currentAvatar);
      formDataAvatar.append("type", "posts");

      const responseAvatar = await upload(formDataAvatar);
      if (responseAvatar.status === 0) {
        this.$message.error(responseAvatar.errors[0]);
        return;
      }
      this.form.photo_url_path = responseAvatar.data[0].path;
    },

    async handleUploadAudio() {
      let formDataAudio = new FormData();
      formDataAudio.append("upload", this.currentAudio);
      formDataAudio.append("type", "audio");

      const responseAudio = await upload(formDataAudio);
      if (responseAudio.status === 0) {
        this.$message.error(responseAudio.errors[0]);
        return;
      }
      this.form.audio_url_path = responseAudio.data[0].path;
    },

    async handleManage() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            this.callingAPI = true;

            if (this.currentAvatar) {
              await this.handleUploadAvatar();
            }
            if (this.currentAudio) {
              await this.handleUploadAudio();
            }

            const data = {
              name: this.form.name,
              slug: this.form.slug,
              description: this.form.description,
              content: this.form.content,
              photo_url_path: this.form.photo_url_path,
              audio_url_path: this.form.audio_url_path,
              meta_title: this.form.metaTitle,
              meta_description: this.form.metaDescription,
              meta_keyword: this.form.metaKeyword,
              show_home: this.form.show_home,
            };
            let response = null;
            if (this.$route.params.id) {
              data.status = this.form.status;
              response = await updatePodcast(this.$route.params.id, data);
            } else {
              response = await createPodcast(data);
            }
            this.callingAPI = false;
            this.$router.push({ name: "ManagePodcast" });
            if (response.status == 1) {
              const message = this.$route.params.id
                ? "Cập nhật podcast thành công."
                : "Thêm podcast thành công.";
              this.$notify.success({
                title: "Thành công",
                message: message,
                duration: 2000,
              });
            } else {
              this.$notify.error({
                title: "Thất bại",
                message: response.errors[0],
                duration: 2000,
              });
            }
          } catch (error) {
            const message = this.$route.params.id
              ? "Cập nhật podcast thất bại."
              : "Thêm podcast thất bại.";
            this.$notify.error({
              title: "Thất bại",
              message: message,
              duration: 2000,
            });
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#preview-avatar {
  max-width: 100%;
  object-fit: contain;
  display: block;
}
#audio {
  display: block;
  margin-top: 15px;
}
.markdown-editor {
  display: inline-block;
  width: 100%;
  .v-note-wrapper {
    min-height: 500px;
    z-index: 1;
  }
}
</style>
